import {
  isAvailable,
  priceProvenanceText,
  valuationMessageFor,
  valuationWarningBadgeFor,
} from "../../../services/valuation";
import { HistoryPointView, PointDetails } from "./types";

// A market quote is the default, so the readout names the source only when a manual price is in the mix; the data table keeps the full provenance.
export const pointDetailsOf = (point: HistoryPointView): PointDetails => {
  const isBlocked = !isAvailable(point.valuation);
  const hasManualPrice = point.priceProvenances.some(
    (kind) => kind !== "provider",
  );
  return {
    source:
      hasManualPrice && !isBlocked
        ? priceProvenanceText(point.priceProvenances)
        : null,
    warnings: point.warnings.map((warning) => ({
      key: `${warning.code}-${warning.instrumentId}`,
      badge: valuationWarningBadgeFor(warning),
    })),
    blockedMessage: isBlocked ? valuationMessageFor(point.valuation) : null,
  };
};

export const pointDetailsTextOf = (point: HistoryPointView): string[] => {
  const { source, warnings, blockedMessage } = pointDetailsOf(point);
  return [
    ...(source ? [`Source: ${source}`] : []),
    ...warnings.map(({ badge }) => `${badge.label}: ${badge.message}`),
    ...(blockedMessage ? [blockedMessage] : []),
  ];
};
